require('../../../modules/es.string.trim');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').trim;